/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, Outlet } from "react-router-dom";

import { FiSettings } from "react-icons/fi";
import { ReactComponent as LinkIcon } from "../../assets/dashboard/link.svg";
import { ReactComponent as LinkIconDark } from "../../assets/dashboard/link-dark.svg";
import { useSelector } from "react-redux";
import DashboardMobilePreview from "../../pages/previewPage/dashboardMobilePreview/DashboardMobilePreview";
import useSettings from "../../hooks/useSettings";
import { CopyToClipboard } from "react-copy-to-clipboard";
import toast from "react-hot-toast";

// Side bar with Preview Mobile screen

const SideBarWithMobile = () => {
  const { darkMode } = useSelector((state) => state.theme);
  //  default values for pageName
  const { themeDirection } = useSettings();
  const user_data = useSelector(
    (state) => state?.adminUser?.viewUserData?.user_data
  );
  const [text, setText] = useState("");
  useEffect(() => {
    const url = window.location.origin + "/bill/" + user_data?.pageName;
    setText(url);
  }, [user_data]);
  // state to show the snack bar
  const [copyState, setcopyState] = useState(false);

  return (
    <>
      <div className="bg-white dark:bg-dark-secondary">
        <div className="flex flex-row">
          <div className="bg-gray-100  dark:bg-dark-secondary h-[100vh] w-full md:w-[53%] lg:w-[57.5%] overflow-y-auto">
            <Outlet />
          </div>
          <div className="hidden md:flex justify-center md:w-[47%] lg:w-[42.5%] overflow-y-auto h-[100vh] 4xl:items-center">
            <div className=" max-w-[280px] lg:max-w-[305px] min-w-[270px] lg:min-w-[301px] w-full my-[102px] lg:my-[102px] xl:my-[102px] h-max">
              <CopyToClipboard text={text} onCopy={() => setcopyState(true)}>
                <a href={text} target="_blank" rel="noopener noreferrer">
                  <div
                    className={`py-[7px] mt-6 px-[10px] mb-4 bg-light_bg_v3  dark:bg-[#404040] flex items-center gap-2 rounded-md ${
                      themeDirection === "rtl" ? "flex-row-reverse" : ""
                    }`}
                  >
                    <div>{darkMode ? <LinkIconDark /> : <LinkIcon />}</div>
                    <p className="text-small3 text-dark_bg_v4 dark:text-color_v1_dark">
                      URL : bilbio/{user_data?.pageName}
                    </p>
                  </div>
                </a>
              </CopyToClipboard>
              <div className="flex justify-center items-center ">
                <div className="w-full max-w-[280px] lg:max-w-[305px] min-w-[270px] lg:min-w-[301px] min-h-[650px] h-[650px] max-h-[650px] overscroll-y-auto bg-[#FFDDDB] rounded-[30px] no-scrollbar">
                  <div className="rounded-[30px] h-full w-full overflow-y-auto p-0 border no-scrollbar">
                    <DashboardMobilePreview user={user_data?.pageName} />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBarWithMobile;
